import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  GridCol,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
  rem,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { modals } from "@mantine/modals";
import {
  IconActivity,
  IconBarcode,
  IconCaretDown,
  IconCheck,
  IconCopy,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileLike,
  IconFileUpload,
  IconListCheck,
  IconPlus,
  IconReceiptDollar,
  IconRefresh,
  IconSearch,
  IconStatusChange,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_Row,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { BASE_API_POS } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDmEmployee } from "../../../model/TblDmEmployee";
import { tblPromotionGetList } from "../../../model/TblPromotion";
import CloneView from "./CloneView";
import DeleteView from "./DeleteView";
import ModalApprovePromotion from "./ModalApprovePromotion";
import ProfitRevenue from "./ProfitRevenue";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";

function getColorStatus(status: string, effDate: Date, expDate: Date): string {
  const now = new Date();
  const effectiveDate = effDate ? new Date(effDate) : null;
  const expirationDate = expDate ? new Date(expDate) : null;
  switch (status) {
    case "2": // Đã duyệt
      if (effectiveDate && expirationDate) {
        if (now >= effectiveDate && now <= expirationDate) {
          return "teal"; // Đang chạy
        } else if (now > expirationDate) {
          return "gray"; // Hết hiệu lực
        } else if (now < effectiveDate) {
          return "teal.4"; // Hết hiệu lực
        }
        return "teal";
      }
      return "blue"; // Đang xét duyệt
    case "3": // Dừng duyệt
      return "yellow"; // Đang xét duyệt (có thể chỉnh sửa, không cho xóa)
    case "4": // Từ chối
      return "red"; // Không áp dụng (có thể sửa, không cho xóa)
    case "5": // Hủy duyệt
      return "blue"; // Chưa áp dụng (có thể sửa, không cho xóa)
    default: // Chưa duyệt
      return "blue"; // Đang xét duyệt (có thể chỉnh sửa, có thể xóa)
  }
}

function getStatus(text: any) {
  switch (text) {
    case "2":
      return "Đã duyệt";
    case "3":
      return "Tạm dừng";
    case "4":
      return "Từ chối";
    case "5":
      return "Hủy duyệt";
    default:
      return "Chưa duyệt";
  }
}

function getStatus2(
  text: any,
  effDate?: string | Date,
  expDate?: string | Date,
): string {
  const now = new Date();
  const effectiveDate = effDate ? new Date(effDate) : null;
  const expirationDate = expDate ? new Date(expDate) : null;

  switch (text) {
    case "2": // Đã duyệt
      if (effectiveDate && expirationDate) {
        if (now >= effectiveDate && now <= expirationDate) {
          return "Đang chạy";
        } else if (now > expirationDate) {
          return "Hết hiệu lực";
        } else if (now < effectiveDate) {
          return "Chưa đến thời gian chạy";
        }
      }
      return "Đang xét duyệt";
    case "3": // Dừng duyệt
      return "Đang xét duyệt";
    case "4": // Từ chối
      return "Không áp dụng ";
    case "5": // Hủy duyệt
      return "Chưa áp dụng";
    default: // Chưa duyệt
      return "Chưa duyệt";
  }
}

const sizeGrid = { base: 12, sm: 6, lg: 2 };

const PromotionPolicy = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [pagination, setPagination] = useState(paginationBase);
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [data, setData] = useState<tblPromotionGetList[]>([]);
  // const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState({
    effDate: _searchJson && checkedPinSearch ? _searchJson?.effDate : "",
    expDate: _searchJson && checkedPinSearch ? _searchJson?.expDate : "",
    fromApproveDate:
      _searchJson && checkedPinSearch ? _searchJson?.fromApproveDate : "",
    toApproveDate:
      _searchJson && checkedPinSearch ? _searchJson?.toApproveDate : "",
    approveStatus:
      _searchJson && checkedPinSearch ? _searchJson?.approveStatus : "",
    type: _searchJson && checkedPinSearch ? _searchJson?.type : "",
    itemCode: _searchJson && checkedPinSearch ? _searchJson?.itemCode : "",
    itemGiftCode:
      _searchJson && checkedPinSearch ? _searchJson?.itemGiftCode : "",
    status: _searchJson && checkedPinSearch ? _searchJson?.status : "",
    createBy: _searchJson && checkedPinSearch ? _searchJson?.createBy : "",
    approveBy: _searchJson && checkedPinSearch ? _searchJson?.approveBy : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch || "" : "",
    300,
  );
  const [dataItemCode, setDataItemCode] = useState<ComboboxItem[]>([]);
  const [dataItemGiftCode, setDataItemGiftCode] = useState<ComboboxItem[]>([]);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [dataEmployee, setDataEmployee] = useState<TblDmEmployee[]>([]);
  const [dataEmployeeCreateBy, setDataEmployeeCreateBy] = useState<
    TblDmEmployee[]
  >([]);
  const [dataEmployeeApproved, setDataEmployeeApproved] = useState<
    TblDmEmployee[]
  >([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const dataStatus = React.useMemo<any[]>(
    () => [
      {
        value: "1",
        label: "Chưa duyệt",
      },
      {
        value: "2",
        label: "Đã duyệt",
      },
      {
        value: "3",
        label: "Tạm dừng",
      },
      {
        value: "4",
        label: "Từ chối",
      },
      {
        value: "5",
        label: "Hủy duyệt",
      },
    ],
    [],
  );

  const statusPromotion = [
    { value: "1", label: "Chưa duyệt" },
    { value: "2", label: "Đang chạy" },
    { value: "3", label: "Hết hiệu lực" },
    { value: "4", label: "Chưa đến thời gian chạy" },
    { value: "5", label: "Đang xét duyệt" },
    { value: "6", label: "Không áp dụng" },
    { value: "7", label: "Chưa áp dụng" },
  ];

  const dataType = [
    { value: "1", label: "CTKM thông thường" },
    { value: "2", label: "Flash Sale" },
    { value: "4", label: "Deal sốc" },
  ];

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "code",
        header: "Mã chính sách",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() =>
                navigate("/config-system/detail-promotion", {
                  state: { id: row.id, type: "single" },
                })
              }
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "approveStatus1",
        header: "Trạng thái duyệt",
        Cell: ({ renderedCellValue, row, cell }) => (
          <>
            <Badge
              color={getColorStatus(
                row.original.approveStatus,
                row.original.effDate,
                row.original.expDate,
              )}
            >
              {getStatus(row.original.approveStatus)}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "approveStatus",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row, cell }) => (
          <>
            <Badge
              color={getColorStatus(
                row.original.approveStatus,
                row.original.effDate,
                row.original.expDate,
              )}
            >
              {getStatus2(
                row.original.approveStatus,
                row.original.effDate,
                row.original.expDate,
              )}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "note",
        header: "Tên chương trình",
        size: 500,
      },
      {
        accessorKey: "type",
        header: "Chính sách khuyến mãi",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataType, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "attribute2",
        header: "Mã chính sách Copy",
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <></>;
        },
      },
      {
        accessorKey: "createBy",
        header: "Người tạo",
        //  size: 100,
        enableSorting: false,
      },
      {
        accessorKey: "effDate",
        header: "Thời gian hiệu lực",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <></>;
        },
      },
      {
        accessorKey: "expDate",
        header: "Thời gian hết hạn",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <></>;
        },
      },

      {
        accessorKey: "priority",
        header: "Độ ưu tiên",
        // size: 100,
      },

      {
        accessorKey: "approveBy",
        header: "Người duyệt",
        //  size: 100,
        enableSorting: false,
        Cell: ({ renderedCellValue, cell }) =>
          getEmployeeName(renderedCellValue?.toString() || ""),
      },
      {
        accessorKey: "approveDate",
        header: "Ngày duyệt",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <></>;
        },
      },
      {
        accessorKey: "lastUpdateBy",
        header: "Người cập nhật cuối",
        //  size: 100,
        enableSorting: false,
        Cell: ({ renderedCellValue, cell }) =>
          renderedCellValue?.toString() || "",
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật cuối",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <></>;
        },
      },
      {
        accessorKey: "approveNote",
        header: "Ghi chú duyệt",
        // size: 100,
      },

      // {
      //   accessorKey: "listCustGroup",
      //   header: "Danh sách khách hàng",
      // },

      // {
      //   accessorKey: "listOtherCondition",
      //   header: "Danh sách tình trạng khác",
      // },

      // {
      //   accessorKey: "checkNomalPromote",
      //   header: "Check chính sách thường",
      // },

      // {
      //   accessorKey: "checkRewardPoint",
      //   header: "Check Điểm thưởng",
      // },

      // {
      //   accessorKey: "checkUploadWebsite",
      //   header: "Check upload web",
      // },

      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        size: 175,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    [dataEmployee, dataType],
  );

  function processTaskActionMenu(row: MRT_Row<any>): any {
    const checkdadieukienMultiCondition = row.original.attribute4 === "1";
    return (
      <>
        {!(
          row.original.approveStatus === "2" ||
          row.original.approveStatus === "4"
        ) && (
          <Tooltip label="Duyệt chính sách">
            <ActionIcon
              variant="light"
              aria-label="Settings"
              color="teal"
              onClick={async () => {
                handleApprovePromotion([row.id]);
              }}
            >
              <IconFileLike size={20} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        )}

        {row.original.approveStatus !== "2" &&
          row.original.approveStatus !== "5" && (
            <Tooltip label="Sửa chính sách">
              <ActionIcon variant="light" aria-label="Settings" color="yellow">
                <IconEdit
                  size={14}
                  stroke={1.5}
                  onClick={() =>
                    navigate(`/config-system/edit-promotion/${row.id}`, {
                      state: {
                        multiCondition: checkdadieukienMultiCondition
                          ? true
                          : false,
                      },
                    })
                  }
                />
                {/* {checkdadieukienMultiCondition && (
                  <span style={{ color: "red", marginLeft: 4 }}>@</span>
                )} */}
              </ActionIcon>
            </Tooltip>
          )}
        <Tooltip label="Xem chi tiết">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="cyan"
            onClick={async () => {
              handleDetailPromotion(row);
            }}
          >
            <IconEye size={20} stroke={1.5} />
            {/* {checkdadieukienMultiCondition && (
              <span style={{ color: "red", marginLeft: 4 }}>@</span>
            )} */}
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Sao chép">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="blue"
            onClick={async () => {
              await cloneData(Number.parseInt(row.id));
            }}
          >
            <IconCopy size={20} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        {row.original.approveStatus === "1" && (
          <Tooltip label="Xóa chính sách">
            <ActionIcon
              variant="light"
              aria-label="Settings"
              color="red"
              onClick={async () => {
                await deletesData([row.id]);
              }}
            >
              <IconTrash size={14} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        )}
        {row.original.approveStatus === "2" && (
          <Tooltip label="Doanh thu dự kiến">
            <ActionIcon
              variant="light"
              aria-label="Settings"
              color="orange"
              onClick={() => modalsProfitRevenue(row.original.code)}
            >
              <IconReceiptDollar size={20} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        )}
      </>
    );
  }

  const getEmployeeName = (id: string) => {
    const employee = dataEmployee.find(
      (employee) => employee.id.toString() === id,
    );

    return employee?.fullname;
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    if (value !== "Invalid date")
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    else {
      setSearch((prevData) => ({ ...prevData, [key]: "" }));
    }
  };

  const handleExport = async () => {
    open();
    try {
      let url = `/api/v1/tblPromotion/export?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (search.effDate) {
        url += `&EffDate=${search.effDate}`;
      }
      if (search.expDate) {
        url += `&ExpDate=${search.expDate}`;
      }

      if (search.fromApproveDate) {
        url += `&FromApproveDate=${search.fromApproveDate}`;
      }
      if (search.toApproveDate) {
        url += `&ToApproveDate=${search.toApproveDate}`;
      }

      if (search.approveStatus) {
        url += `&ApproveStatus=${search.approveStatus}`;
      }

      if (search.type && search.type.length > 0) {
        url += `&Type=${search.type}`;
      }
      if (search.itemCode && search.itemCode.length > 0) {
        url += `&ItemPrimaryCode=${search.itemCode}`;
      }
      if (search.itemGiftCode && search.itemGiftCode.length > 0) {
        url += `&ItemGiftCode=${search.itemGiftCode}`;
      }
      if (search.status && search.status.length > 0) {
        url += `&Status=${search.status}`;
      }

      if (search.createBy && search.createBy.length > 0) {
        url += `&CreateBy=${search.createBy}`;
      }
      if (search.approveBy && search.approveBy.length > 0) {
        url += `&ApproveBy=${search.approveBy}`;
      }
      if (sorting && sorting.length > 0) {
        let _q = sorting[0];
        if (_q) {
          url = url + "&sort=" + _q.id + "&isOrder=" + _q.desc;
        }
      }

      const _url = BASE_API_POS + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_sach_CTKM" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const deletesData = async (ids: string[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Xóa chính sách khuyến mãi!</Title>
            </>
          ),
          size: "550px",
          children: <DeleteView idItems={ids} fetchData={fetchData} />,
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const cloneData = async (id: number) => {
    if (id < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    else
      try {
        modals.openConfirmModal({
          title: (
            <>
              <Title order={5}>Sao chép chính sách khuyến mãi!</Title>
            </>
          ),
          size: "550px",
          children: <CloneView id={id} fetchData={fetchData} />,
          confirmProps: { display: "none" },
          cancelProps: { display: "none" },
        });
      } catch (error) {
        console.error(error);
        return;
      }
  };

  const modalsProfitRevenue = (promotionCode: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Doanh thu CTKM dự kiến</Title>,
      size: "90vw",
      children: <ProfitRevenue isModal={true} promotionCode={promotionCode} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      let url = `/api/v1/tblPromotion/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (search.effDate) {
        url += `&EffDate=${search.effDate}`;
      }
      if (search.expDate) {
        url += `&ExpDate=${search.expDate}`;
      }

      if (search.fromApproveDate) {
        url += `&FromApproveDate=${search.fromApproveDate}`;
      }
      if (search.toApproveDate) {
        url += `&ToApproveDate=${search.toApproveDate}`;
      }

      if (search.approveStatus) {
        url += `&ApproveStatus=${search.approveStatus}`;
      }

      if (search.type && search.type.length > 0) {
        url += `&Type=${search.type}`;
      }
      if (search.itemCode && search.itemCode.length > 0) {
        url += `&ItemPrimaryCode=${search.itemCode}`;
      }
      if (search.itemGiftCode && search.itemGiftCode.length > 0) {
        url += `&ItemGiftCode=${search.itemGiftCode}`;
      }

      if (search.status && search.status.length > 0) {
        url += `&Status=${search.status}`;
      }

      if (search.createBy && search.createBy.length > 0) {
        url += `&CreateBy=${search.createBy}`;
      }
      if (search.approveBy && search.approveBy.length > 0) {
        url += `&ApproveBy=${search.approveBy}`;
      }
      if (sorting && sorting.length > 0) {
        let _q = sorting[0];
        if (_q) {
          url = url + "&sort=" + _q.id + "&isOrder=" + _q.desc;
        }
      }

      const response =
        await repositoryPos.get<MessageResponse<tblPromotionGetList[]>>(url);

      if (response && response.success) {
        setData(response.data);
        setRowCount(response.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
  };
  const DataItemCode = async (
    keySearch: string,
    type: "itemCode" | "itemGiftCode",
  ) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      const response = await repositoryPos.get(
        `api/v1/tblitem/get-select?key=${encodeURIComponent(
          keySearch,
        )}&page=25` + url,
      );
      if (response && response.success) {
        const transformedData = response.data.map((branch: any) => ({
          value: branch.value,
          label: branch.text,
        }));

        // Phân biệt theo type để set data vào state tương ứng
        if (type === "itemCode") {
          setDataItemCode(transformedData);
        } else if (type === "itemGiftCode") {
          setDataItemGiftCode(transformedData);
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  const handleCreatePP = () => {
    navigate("/config-system/create-promotion-policy");
    localStorage.removeItem("policyType");
  };

  const handleApprovePromotion = (ids: string[]) => {
    modals.openConfirmModal({
      size: "500px",
      title: (
        <>
          <Title order={5}>Duyệt chính sách khuyến mại</Title>
        </>
      ),
      children: <ModalApprovePromotion ids={ids} fetchData={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  // Chỗ call đồng bộ phiếu
  const handleDongBo = async (ids: string[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblPromotion/Sync-flash",
        ids,
      );
      if (response && response.success) {
        NotificationExtension.Success("Đồng bộ thành công !");
      } else {
        NotificationExtension.Fails("Đồng bộ thất bại !");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  // đồng bộ ctkm
  const handleDongBoV2 = async (ids: string[]) => {
    if (ids.length < 1) NotificationExtension.Warn("Bạn chưa chọn dữ liệu !");
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblPromotion/sync-promotion",
        {
          ids: ids,
        },
      );
      if (response && response.success) {
        NotificationExtension.Success("Đồng bộ thành công !");
      } else {
        NotificationExtension.Fails("Đồng bộ thất bại !");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleEditPromotion = (id: string) => {
    navigate("/config-system/edit-promotion/" + id);
    //  localStorage.removeItem("policyType");
  };

  const handleDetailPromotion = (row: MRT_Row<any>): any => {
    const checkDadieuKien = row.original?.attribute4 === "1";
    navigate("/config-system/detail-promotion", {
      state: { id: row.id, type: `${checkDadieuKien ? "multi" : "single"}` },
    });
    localStorage.removeItem("policyType");
  };

  const optionColorsStatusPromotion: Record<
    | "Chưa duyệt"
    | "Đang chạy"
    | "Hết hiệu lực"
    | "Chưa đến thời gian chạy"
    | "Đang xét duyệt"
    | "Không áp dụng"
    | "Chưa áp dụng",
    string
  > = {
    "Chưa duyệt": "blue",
    "Đang chạy": "teal",
    "Hết hiệu lực": "gray",
    "Chưa đến thời gian chạy": "teal.4",
    "Đang xét duyệt": "yellow",
    "Không áp dụng": "red",
    "Chưa áp dụng": "blue",
  };

  const renderSelectOptionStatusPromotion: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsStatusPromotion[
            option.label as
              | "Chưa duyệt"
              | "Đang chạy"
              | "Hết hiệu lực"
              | "Chưa đến thời gian chạy"
              | "Đang xét duyệt"
              | "Không áp dụng"
              | "Chưa áp dụng"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  const optionColorsStatus: Record<
    "Chưa duyệt" | "Đã duyệt" | "Tạm dừng" | "Từ chối" | "Hủy duyệt",
    string
  > = {
    "Chưa duyệt": "blue",
    "Đã duyệt": "teal",
    "Tạm dừng": "yellow",
    "Từ chối": "red",
    "Hủy duyệt": "gray",
  };

  const renderSelectOptionStatus: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsStatus[
            option.label as
              | "Chưa duyệt"
              | "Đã duyệt"
              | "Tạm dừng"
              | "Từ chối"
              | "Hủy duyệt"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  useEffect(() => {
    const fetchDataEmployee = async () => {
      try {
        let url = `/api/v1/tblDmEmployee/get-all`;

        const response =
          await repositoryPos.get<MessageResponse<TblDmEmployee[]>>(url);

        if (response && response.success) {
          setDataEmployee(response.data);
          setDataEmployeeCreateBy(response.data);
          setDataEmployeeApproved(response.data);
        }
      } catch (error) {
        return;
      }
    };

    fetchDataEmployee();

    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (145 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEffect(() => {
  //   const valuesList = Object.keys(rowSelection);
  //   setSelectIds(valuesList);
  //   if (valuesList.length < 1) setSelectIds([]);
  //   else {
  //     const valuesList = Object.keys(rowSelection);
  //     setSelectIds(valuesList);
  //   }
  // }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  // Đồng bộ keySearch với sessionStorage và tự động fetch data
  useEffect(() => {
    if (keySearch !== (_searchJson?.keySearch || "")) {
      // Chỉ fetch data nếu keySearch thay đổi và không phải lần đầu mount
      fetchData();
    }
  }, [keySearch]);

  // Load dữ liệu cho Select khi component mount nếu có giá trị được khôi phục
  useEffect(() => {
    // Load data cho itemCode nếu có giá trị
    if (search.itemCode && search.itemCode.length > 0) {
      // Gọi API để load danh sách có chứa item được chọn
      DataItemCode(search.itemCode, "itemCode");

      // Đồng thời thêm item hiện tại vào data nếu chưa có
      const currentItem = {
        value: search.itemCode,
        label: search.itemCode, // Tạm thời dùng code làm label
      };
      setDataItemCode((prev) => {
        const exists = prev.some((item) => item.value === search.itemCode);
        return exists ? prev : [currentItem, ...prev];
      });
    }

    // Load data cho itemGiftCode nếu có giá trị
    if (search.itemGiftCode && search.itemGiftCode.length > 0) {
      // Gọi API để load danh sách có chứa item được chọn
      DataItemCode(search.itemGiftCode, "itemGiftCode");

      // Đồng thời thêm item hiện tại vào data nếu chưa có
      const currentItem = {
        value: search.itemGiftCode,
        label: search.itemGiftCode, // Tạm thời dùng code làm label
      };
      setDataItemGiftCode((prev) => {
        const exists = prev.some((item) => item.value === search.itemGiftCode);
        return exists ? prev : [currentItem, ...prev];
      });
    }
  }, []); // Chỉ chạy một lần khi component mount

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    // renderTopToolbarCustomActions: ({ table }) => (

    // ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row?.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "code", "approveStatus1"],
        right: ["applicableObject", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500",
        fontSize: "11.5px",
        padding: "4px 12px",
      },
    }),
    // enableColumnDragging: true,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      // rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },

    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });

  return (
    <>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <Box
        style={{ border: "1px solid #dee2e6", padding: "5px", width: "100%" }}
        ref={headerRef}
        pb={10}
      >
        <Flex justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Flex gap="md" justify={"flex-end"} align="center" direction="row">
            <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={handleCreatePP}
            >
              Thêm mới (F11)
            </Button>
            <Button
              leftSection={<IconRefresh size={14} />}
              color="cyan"
              variant="cyan"
              onClick={async () => {
                const select = table
                  .getSelectedRowModel()
                  .rows.map((row) => row.original);
                if (select.length > 0)
                  await handleDongBo(select.map((item) => item.id));
                else NotificationExtension.Fails("Chọn dữ liệu để thao tác !");
              }}
            >
              Đồng bộ Flash Sale
            </Button>
            <Button
              leftSection={<IconRefresh size={14} />}
              color="blue"
              variant="filled"
              onClick={async () => {
                const select = table
                  .getSelectedRowModel()
                  .rows.map((row) => row.original);
                if (select.length > 0)
                  await handleDongBoV2(select.map((item) => item.id));
                else NotificationExtension.Fails("Chọn dữ liệu để thao tác !");
              }}
            >
              Đồng bộ CTKM
            </Button>
            <Button
              leftSection={<IconActivity size={14} />}
              color="violet"
              variant="outline"
              onClick={async () => {
                const select = table
                  .getSelectedRowModel()
                  .rows.map((row) => row.original);
                if (select.length > 0)
                  await handleApprovePromotion(select.map((item) => item.id));
                else NotificationExtension.Fails("Chọn dữ liệu để thao tác !");
              }}
            >
              Cập nhật trạng thái
            </Button>

            <Button
              leftSection={<IconTrash size={14} />}
              color="red"
              variant="outline"
              onClick={async () => {
                const select = table
                  .getSelectedRowModel()
                  .rows.map((row) => row.original);
                if (select.length > 0)
                  await deletesData(select.map((item) => item.id));
                else NotificationExtension.Fails("Chọn dữ liệu để thao tác !");
              }}
            >
              Xóa (đã chọn)
            </Button>

            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
        <Grid mt={15}>
          <GridCol span={sizeGrid}>
            <TextInput
              flex={1}
              placeholder="Từ khoá"
              leftSection={<IconSearch color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => {
                setKeySearch(e.currentTarget.value);
              }}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              flex={1}
              placeholder="Trạng thái duyệt"
              leftSection={<IconStatusChange color="#15aabf" />}
              clearable
              data={dataStatus}
              value={
                search.approveStatus && search?.approveStatus?.length > 0
                  ? search.approveStatus
                  : ""
              }
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              renderOption={renderSelectOptionStatus}
              onChange={(e) => {
                handleChangeSearchValue(e ?? "", "approveStatus");
              }}
            />
          </GridCol>
          <GridCol span={sizeGrid}>
            <Select
              flex={1}
              placeholder="Trạng thái"
              leftSection={<IconStatusChange color="#15aabf" />}
              clearable
              data={statusPromotion}
              value={
                search.status && search?.status?.length > 0 ? search.status : ""
              }
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              renderOption={renderSelectOptionStatusPromotion}
              onChange={(e) => {
                handleChangeSearchValue(e ?? "", "status");
              }}
            />
          </GridCol>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              flex={1}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Hiệu lực từ ngày"
              locale="vi"
              value={
                search?.effDate && search?.effDate?.length > 0
                  ? new Date(search?.effDate || "")
                  : null
              }
              //   value={value}
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  e
                    ? new Date(
                        new Date(e ?? "")?.getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "effDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              flex={1}
              placeholder="Hiệu lực đến ngày"
              locale="vi"
              value={
                search?.expDate && search?.expDate?.length > 0
                  ? new Date(search?.expDate || "")
                  : null
              }
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  e
                    ? new Date(
                        new Date(e ?? "")?.getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "expDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          {/* <GridCol span={sizeGrid}>
            <DatePickerInput
              // type="multiple"
              type="range"
              size="sm"
              placeholder="Thời gian hiệu lực từ ngày - đến ngày"
              locale="vi"
              // value={value}
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e[0]) ?? "",
                  "effDate"
                );
                handleChangeSearchValue(
                  formatDateNotTimeZone(e[1]) ?? "",
                  "expDate"
                );
              }}
              clearable
            />
          </GridCol> */}
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Duyệt từ ngày"
              locale="vi"
              value={
                search?.fromApproveDate && search?.fromApproveDate?.length > 0
                  ? new Date(search?.fromApproveDate || "")
                  : null
              }
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                const startDateISO = e ? e.toLocaleDateString() : null;
                handleChangeSearchValue(startDateISO ?? "", "fromApproveDate");
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Duyệt đến ngày"
              locale="vi"
              value={
                search?.toApproveDate && search?.toApproveDate?.length > 0
                  ? new Date(search?.toApproveDate || "")
                  : null
              }
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                const startDateISO = e ? e.toLocaleDateString() : null;
                handleChangeSearchValue(startDateISO ?? "", "toApproveDate");
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Chính sách khuyến mãi"
              leftSection={<IconListCheck color="#15aabf" />}
              data={dataType}
              value={search.type && search?.type?.length > 0 ? search.type : ""}
              clearable
              onChange={(e) => handleChangeSearchValue(e ? e : "", "type")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Chọn mã sản phẩm hàng chính"
              data={dataItemCode}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              value={
                search?.itemCode && search?.itemCode?.length > 0
                  ? search?.itemCode
                  : ""
              }
              clearable
              searchable
              onChange={(e) => handleChangeSearchValue(e ? e : "", "itemCode")}
              onSearchChange={(value) => {
                if (value.length >= 3) {
                  DataItemCode(value, "itemCode");
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Chọn mã sản phẩm hàng tặng"
              data={dataItemGiftCode}
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              value={
                search?.itemGiftCode && search?.itemGiftCode?.length > 0
                  ? search?.itemGiftCode
                  : ""
              }
              clearable
              searchable
              onChange={(e) =>
                handleChangeSearchValue(e ? e : "", "itemGiftCode")
              }
              onSearchChange={(value) => {
                if (value.length >= 3) {
                  DataItemCode(value, "itemGiftCode");
                }
              }}
            />
          </Grid.Col>
          {/* <GridCol span={sizeGrid}>
            <DatePickerInput
              // type="multiple"
              type="range"
              size="sm"
              placeholder="Duyệt từ ngày - đến ngày"
              locale="vi"
              // value={value}
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e[0]) ?? "",
                  "fromApproveDate"
                );
                handleChangeSearchValue(
                  formatDateNotTimeZone(e[1]) ?? "",
                  "toApproveDate"
                );
              }}
              clearable
            />
          </GridCol> */}
          <Grid.Col span={sizeGrid}>
            <Select
              flex={1}
              placeholder="Người tạo"
              leftSection={<IconSearch color="#15aabf" />}
              data={Array.from(
                new Set(
                  dataEmployeeCreateBy
                    .map((item) => item.fullname)
                    .filter(
                      (fullname): fullname is string =>
                        typeof fullname === "string" && fullname.length > 0,
                    ),
                ),
              ).map((fullname) => ({
                value: fullname,
                label: fullname,
              }))}
              value={
                search.createBy && search.createBy.length > 0
                  ? search.createBy
                  : ""
              }
              searchable
              clearable
              onChange={(e) => handleChangeSearchValue(e ? e : "", "createBy")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              flex={1}
              placeholder="Người duyệt"
              leftSection={<IconSearch color="#15aabf" />}
              data={dataEmployeeApproved.map((item) => ({
                value: String(item.id) ?? "",
                label: item.fullname ?? "",
              }))}
              value={
                search.approveBy && search.approveBy.length > 0
                  ? search.approveBy
                  : ""
              }
              searchable
              clearable
              onChange={(e) => handleChangeSearchValue(e ? e : "", "approveBy")}
            />
          </Grid.Col>
          <GridCol span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </GridCol>
        </Grid>
      </Box>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default PromotionPolicy;
